<!--  -->
<template>
  <div class="add_box">
    <div class="search_box">
      <div class="search_box">
        <el-input v-model="objr.keywords" style="width:300px;" placeholder="请输入企业ID/名称" />
        <el-input v-model="objr.order_id" style="width:300px;" placeholder="请输入订单ID" />
        <el-button type="primary" icon="el-icon-search" @click="sraw">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="awered">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="addbit">新增订单</el-button>
      </div>
    </div>

    <!-- <el-button type="primary" @click="awered">重置</el-button> -->
    <el-table
      :data="tableData"
      border
      style="width: 100%;margin-top:20px"
    >
      <el-table-column
        prop="corp_name_inner"
        label="企业名称"
        width="190"
        align="center"
      />
      <el-table-column
        prop="corp_id"
        label="企业ID"
        width="200"
        align="center"
      />
      <el-table-column
        prop="buyer_userid"
        label="购买人userID"
        width="150"
        align="center"
      />
      <el-table-column
        prop="base_count"
        label="基础帐号个数"
        width="80"
        align="center"
      />
      <el-table-column
        prop="external_contact_count"
        label="互通帐号个数"
        width="80"
        align="center"
      />
      <el-table-column
        prop="months"
        label="购买的月数"
        width="80"
        align="center"
      />
      <el-table-column
        prop="days"
        label="购买的天数"
        width="80"
        align="center"
      />
      <el-table-column
        prop="order_id"
        label="订单ID"
        width="180"
        align="center"
      />
      <el-table-column
        prop="order_id"
        label="订单金额(元)"
        width="130"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.price/100 }}
        </template>
      </el-table-column>
      <el-table-column
        prop="order_status_text"
        label="订单状态"
        width="100"
        align="center"
      />
      <el-table-column
        prop="remark"
        label="备注"
        width="180"
        align="center"
      />
      <el-table-column
        prop="realName"
        label="创建人"
        width="100"
        align="center"
      />
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        width="170"
        align="center"
      />
      <el-table-column
        prop="pay_time_text"
        label="支付时间"
        width="170"
        align="center"
      />
      <el-table-column
        prop="updated_at_text"
        label="操作"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="updataorder(scope.row.id)">更新订单</el-button>
          <el-button v-if="scope.row.order_status === 0" type="danger" size="mini" @click="delterorder(scope.row.id)">取消订单</el-button>
          <el-button v-if="scope.row.order_status === 1" type="warning" size="mini" @click="sendorder(scope.row.id)">读取账号</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="新增订单"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="40%"
    >
      <addorder ref="addorderview" @updata="updata" />
    </el-dialog>
    <pagination-right
      ref="paginationbox"
      :current-page="objr.page"
      :total="newtotalr"
      @size-change="fetchPageSizer($event)"
      @current-change="fetchCurrentPager"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { accountAccessindex, accountOrderDetail, accountAccessdelOrder, listOrderAccount } from '@/api/officialaccount.js'
import addorder from './components/addorder.vue'
export default {
  components: {
    PaginationRight,
    addorder
  },
  data() {
    return {
      dialogVisible: false,
      objr: {
        page: 1,
        page_size: 10,
        keywords: null,
        order_id: null
      },
      adtype: null,
      newtotalr: null,
      tableData: []
    }
  },
  created() {
    this.menuList()
  },
  mounted() {

  },
  methods: {
    async menuList() {
      // 获取列表
      const data = await accountAccessindex(this.objr)
      console.log('data', data)
      this.tableData = data.data.list
      this.newtotalr = data.data.total
    },
    sraw() {
      this.objr.page = 1
      this.objr.page_size = 10
      this.menuList()
    },
    awered() {
      this.objr.page = 1
      this.objr.page_size = 10
      this.objr.keywords = null
      this.objr.order_id = null
      this.menuList()
    },
    addbit() {
      this.dialogVisible = true
      this.adtype = 1
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.addorderview.send()
      }, 100)
    },
    // 分页
    fetchPageSizer(e) {
      this.objr.page_size = e
      this.menuList()
    },
    fetchCurrentPager(e) {
      this.objr.page = e
      this.menuList()
    },
    updata() {
      this.dialogVisible = false
      this.menuList()
    },
    async updataorder(id) {
      const data = await accountOrderDetail({
        id: id
      })
      this.$message({
        message: '更新成功',
        type: 'success'
      })
      console.log(data)
      this.menuList()
    },
    async delterorder(id) {
      this.$confirm('此操作将取消该订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        accountAccessdelOrder({
          id: id
        }).then((res) => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.menuList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    async sendorder(id) {
      const data = await listOrderAccount({
        id: id
      })
      this.$message({
        message: '读取成功',
        type: 'success'
      })
      console.log(data)
      this.menuList()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.add_box{
  padding: 20px;
}
.search_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
